export const URL_BUSCAR_SUPLIDORES = "/CxP/WebService/CxpWebService.asmx/BuscarSuplidores";
export const URL_BUSCAR_TIPOS_FACTURACION = "/CxP/WebService/CxpWebService.asmx/BuscarTiposFacturacion";
export const URL_BUSCAR_TIPOS_SUPLIDOR = "/CxP/WebService/CxpWebService.asmx/BuscarTiposSuplidor";
export const URL_BUSCAR_PERIODOS = "/CxC/WebService/CxcWebService.asmx/BuscarPeriodos";
export const URL_BUSCAR_ANTIGUEDAD = "/CxC/WebService/CxcWebService.asmx/BuscarAntiguedad";

export const URL_REPORTE_ESTADO_CUENTA_CXP = "/CxP/WebService/CxpWebService.asmx/EstadoCuentaReporte";
export const URL_REPORTE_SALDO_ANTIGUEDAD_CXP = "/CxP/WebService/CxpWebService.asmx/SaldoAntiguedadReporte";

export class CxpReporteService {
  static consultar(url, opciones) {
    return new Promise(function (resolve, reject) {
      const where = opciones ? { where: { ...opciones } } : null;
      Citrus.AJAX.getJSON(url, where, function (respuesta) {
        var datos = $.parseJSON(respuesta.d);

        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  }

  static consultarEstadoCuenta(where) {
    return this.consultar(
      URL_REPORTE_ESTADO_CUENTA_CXP,
      { ...where },
      {
        EsPaginable: false,
      }
    ).then((res) => {
      return res;
    });
  }

  static consultarSaldoAntiguedad(where) {
    return this.consultar(
      URL_REPORTE_SALDO_ANTIGUEDAD_CXP,
      { ...where },
      {
        EsPaginable: false,
      }
    ).then((res) => {
      return res;
    });
  }

  static consultarSuplidores() {
    return this.consultar(URL_BUSCAR_SUPLIDORES, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }

  static consultarTiposFacturacion() {
    return this.consultar(URL_BUSCAR_TIPOS_FACTURACION).then((res) => res?.Resultados);
  }

  static consultarTiposSuplidor() {
    return this.consultar(URL_BUSCAR_TIPOS_SUPLIDOR, {
      EsPaginable: false,
      EsOrdenable: true,
      OrderBy: "Nombre",
      EsAscendente: true,
    }).then((res) => res?.Resultados);
  }

  static consultarPeriodos() {
    return this.consultar(URL_BUSCAR_PERIODOS, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }

  static consultarAntiguedad() {
    return this.consultar(URL_BUSCAR_ANTIGUEDAD, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }
}
